import { produce } from 'immer'
import { IMessageRecipient } from 'Modules/Communication/shared/models/Inbox'
import {
  ILoadingMessageRecipient,
  SendMessageStateEnum,
  SendMessageStatusEnum,
} from 'shared/models/Message'
import {
  SEND_SMS_CLOSE,
  SEND_SMS_OPEN,
  SEND_SMS_REQUESTED,
  SEND_SMS_SUCCESS,
  SEND_SMS_ERROR,
  SEND_SMS_RESET,
  SEND_SMS_CREATE_DRAFT_SUCCESS,
  SEND_SMS_UPDATE_DRAFT_SUCCESS,
  SEND_SMS_UPDATE_DRAFT_REQUESTED,
  SEND_SMS_SET_STATE,
  SEND_SMS_SET_CREATE_CONTACT,
  SEND_SMS_CREATE_CONTACT_REQUESTED,
  SEND_SMS_CREATE_CONTACT_SUCCESS,
  SEND_SMS_CREATE_CONTACT_FAILED,
  SEND_SMS_FETCH_RECIEPT_ERROR,
  SEND_SMS_IS_COLLAPSED,
  SEND_SMS_FETCH_RECIEPT_REQUESTED,
  SEND_SMS_FETCH_RECIEPT_SUCCESS,
  SEND_SMS_FETCH_SETTINGS_REQUESTED,
  SEND_SMS_FETCH_SETTINGS_SUCCESS,
  SEND_SMS_FETCH_SETTINGS_ERROR,
  SEND_SMS_UPDATE_SENDING_STATUS_ERROR,
  SEND_SMS_UPDATE_SENDING_STATUS_SUCCESS,
  SEND_SMS_REMOVE_RECIPIENT_SUCCESS,
  SEND_SMS_UPDATE_MANY_RECIPIENTS_SUCCESS,
  SEND_SMS_UPDATE_RECIPIENTS_SUCCESS,
  SEND_SMS_RECIPIENTS_TO_LOADING_LIST_REQUESTED,
  SEND_SMS_RECIPIENTS_TO_LOADING_LIST_SUCCESS,
  SEND_SMS_REFETCH_SENDING_STATUS_SUCCESS,
} from './actionTypes'
import { SendSmsActionTypes } from './types'
import { initialSendSmsState } from '../shared/constants'

const initial = initialSendSmsState

const initialState = initial

const reducer = (state = initialState, action: SendSmsActionTypes) => {
  switch (action.type) {
    case SEND_SMS_OPEN:
      return produce(state, (draft) => {
        draft.state = SendMessageStateEnum.send
        draft.message = action.payload?.message || (null as any)
        draft.messageId = action.payload?.draftId || null
        draft.isEditDraft = !!action.payload?.draftId
      })
    case SEND_SMS_CLOSE:
      return produce(state, (draft) => {
        draft.state = null
      })
    case SEND_SMS_SET_STATE:
      return produce(state, (draft) => {
        draft.state = action.payload
      })
    case SEND_SMS_FETCH_SETTINGS_REQUESTED:
      return produce(state, (draft) => {
        draft.settings.loading = true
      })
    case SEND_SMS_IS_COLLAPSED:
      return {
        ...state,
        isCollapsed: action.payload,
      }
    case SEND_SMS_FETCH_SETTINGS_SUCCESS:
      return produce(state, (draft) => {
        draft.settings.loading = false
        draft.settings.data = action.payload
      })
    case SEND_SMS_FETCH_SETTINGS_ERROR:
      return produce(state, (draft) => {
        draft.settings.loading = false
        draft.settings.error = action.payload
      })
    case SEND_SMS_REQUESTED:
      return { ...state, processing: true }
    case SEND_SMS_SUCCESS:
      return produce(state, (draft) => {
        draft.processing = false
        draft.state = SendMessageStateEnum.reciept
      })
    case SEND_SMS_ERROR:
      return { ...state, processing: false, error: action.payload }

    case SEND_SMS_CREATE_DRAFT_SUCCESS:
      return {
        ...state,
        message: action.payload,
        messageId: action.payload.id,
      }
    case SEND_SMS_UPDATE_DRAFT_REQUESTED:
      return produce(state, (draft) => {
        draft.isDraftUpdated = true
      })
    case SEND_SMS_UPDATE_DRAFT_SUCCESS:
      return produce(state, (draft) => {
        if (draft.message) draft.message.content = action.payload
      })

    case SEND_SMS_FETCH_RECIEPT_REQUESTED:
      return produce(state, (draft) => {
        draft.reciept.loading = true
        draft.reciept.error = null
        draft.reciept.messageId = action.payload
      })
    case SEND_SMS_FETCH_RECIEPT_SUCCESS:
      return produce(state, (draft) => {
        draft.reciept.data = action.payload
        draft.reciept.loading = false
      })
    case SEND_SMS_FETCH_RECIEPT_ERROR:
      return produce(state, (draft) => {
        draft.reciept.loading = false
        draft.reciept.error = action.payload
      })
    case SEND_SMS_UPDATE_SENDING_STATUS_SUCCESS:
      return produce(state, (draft) => {
        if (draft.reciept.data)
          draft.reciept.data.sendingStatus = SendMessageStatusEnum.Sent
      })
    case SEND_SMS_UPDATE_SENDING_STATUS_ERROR:
      return produce(state, (draft) => {
        draft.reciept.loading = false
        draft.reciept.error = action.payload
        if (draft.reciept.data)
          draft.reciept.data.sendingStatus = SendMessageStatusEnum.Error
      })
    case SEND_SMS_REFETCH_SENDING_STATUS_SUCCESS:
      return produce(state, (draft) => {
        if (draft.reciept.data)
          draft.reciept.data.sendingStatus = action.payload
      })

    case SEND_SMS_SET_CREATE_CONTACT:
      return produce(state, (draft) => {
        draft.reciept.createContact = action.payload
        draft.reciept.error = null
      })
    case SEND_SMS_CREATE_CONTACT_REQUESTED:
      return produce(state, (draft) => {
        draft.reciept.processing = true
      })
    case SEND_SMS_CREATE_CONTACT_SUCCESS:
      return produce(state, (draft) => {
        draft.reciept.createContact = null
        draft.reciept.processing = false

        const updated = draft.reciept?.data?.recipients?.find(
          (x) =>
            x.email === action.payload.email ||
            x.phonenumber === action.payload.mobile
        )
        if (updated) updated.isAdded = true
      })
    case SEND_SMS_CREATE_CONTACT_FAILED:
      return produce(state, (draft) => {
        draft.reciept.processing = false
        draft.reciept.error = action.payload
      })

    case SEND_SMS_UPDATE_RECIPIENTS_SUCCESS: {
      return produce(state, (draft) => {
        if (!draft.message.recipients?.length) {
          draft.message.recipients = [action.payload]
          return
        }

        // Avoid duplicates from already existing recipients list
        const existing = draft.message.recipients.find(
          (x) =>
            x.phonenumber?.toLowerCase() ===
            action.payload.phonenumber?.toLowerCase()
        )

        if (existing) return

        draft.isDraftUpdated = true
        draft.message.recipients = [...draft.message.recipients, action.payload]
      })
    }

    case SEND_SMS_UPDATE_MANY_RECIPIENTS_SUCCESS: {
      return produce(state, (draft) => {
        if (!draft.message.recipients?.length) {
          draft.message.recipients = action.payload
          return
        }

        // Avoid duplicates from already existing recipients and incoming payload
        const recipients = [
          ...draft.message.recipients,
          ...action.payload.filter(
            (x: IMessageRecipient) =>
              !draft.message.recipients?.find(
                (y) =>
                  y.phonenumber?.toLowerCase() === x.phonenumber?.toLowerCase()
              )
          ),
        ]

        draft.isDraftUpdated = true
        draft.message.recipients = recipients
      })
    }

    case SEND_SMS_REMOVE_RECIPIENT_SUCCESS: {
      return produce(state, (draft) => {
        draft.isDraftUpdated = true
        // Filter away using action payload id or phonenumber
        draft.message.recipients = draft.message.recipients?.filter(
          (x) =>
            x.nameregisterId !== action.payload.nameregisterId ||
            (x.phonenumber !== action.payload.phonenumber &&
              Boolean(x.phonenumber))
        )
      })
    }

    case SEND_SMS_RECIPIENTS_TO_LOADING_LIST_REQUESTED: {
      return produce(state, (draft) => {
        draft.recipientLoadingQueue = action.payload
      })
    }

    case SEND_SMS_RECIPIENTS_TO_LOADING_LIST_SUCCESS: {
      return produce(state, (draft) => {
        // Remove from loading queue that has the same id from the payload
        draft.recipientLoadingQueue = draft.recipientLoadingQueue?.filter(
          (x) =>
            !action.payload.some(
              (y: ILoadingMessageRecipient) =>
                y.id === x.id &&
                y.type === x.type &&
                y.recipientType === x.recipientType
            )
        )
      })
    }

    case SEND_SMS_RESET:
      return initial

    default:
      return state
  }
}

export default reducer
